import { ReactNode } from 'react';

import { ReactComponent as ArrowRightIcon } from 'src/assets/images/arrowRightIcon.svg';
import clsx from 'src/utils/clsx';
import Box from 'src/components/Box';

import styles from './styles';

type ExpandedCellProps = {
  isExpanded: boolean;
  children?: ReactNode;
};

const ExpandedCell: React.FC<ExpandedCellProps> = props => {
  const { isExpanded, children } = props;

  const expandedIconStyles = clsx(styles.icon, [[styles.expandedIcon, isExpanded]]);

  return (
    <Box sx={styles.root}>
      <Box sx={expandedIconStyles}>
        <ArrowRightIcon />
      </Box>
      {children}
    </Box>
  );
};

export default ExpandedCell;
